(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["aurrelle-display-currency"] && !Shopify.designMode) return;
  try {
    (() => {
    const config = document.querySelector('[data-aurrelle-display-currency]');
    if (!config) return;

    const currency = config.dataset.currency;
    const rate = Number(config.dataset.rate);
    if (!currency || !Number.isFinite(rate)) return;

    const formatter = new Intl.NumberFormat(document.documentElement.lang || 'en', {
      style: 'currency',
      currency,
      minimumFractionDigits: 3,
      maximumFractionDigits: 3
    });

    const patterns = [
      /\b(?:AED|Dhs?\.?)\s*([\d,]+(?:\.\d+)?)/gi,
      /([\d,]+(?:\.\d+)?)\s*(?:AED|Dhs?\.?)\b/gi,
      /د\.إ\s*([\d,]+(?:\.\d+)?)/gi
    ];

    const convertAmount = (value) => {
      const amount = Number(value.replaceAll(',', ''));
      return Number.isFinite(amount) ? formatter.format(amount * rate) : value;
    };

    const convertText = (value) => {
      let converted = value;
      patterns.forEach((pattern) => {
        converted = converted.replace(pattern, (_, amount) => convertAmount(amount));
      });
      return converted.replace(/\(AED[^)]*\)/g, `(${currency})`);
    };

    const shouldSkip = (node) => {
      const parent = node.parentElement;
      if (!parent) return true;
      if (parent.closest('[data-aurrelle-display-currency]')) return true;
      return ['SCRIPT', 'STYLE', 'NOSCRIPT', 'TEXTAREA', 'OPTION', 'CODE', 'PRE'].includes(parent.tagName);
    };

    const convertNode = (node) => {
      if (shouldSkip(node)) return;
      const converted = convertText(node.nodeValue || '');
      if (converted !== node.nodeValue) node.nodeValue = converted;
    };

    const convertTree = (root) => {
      if (root.nodeType === Node.TEXT_NODE) {
        convertNode(root);
        return;
      }

      const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
      let node;
      while ((node = walker.nextNode())) convertNode(node);
    };

    convertTree(document.body);

    new MutationObserver((records) => {
      records.forEach((record) => {
        record.addedNodes.forEach(convertTree);
      });
    }).observe(document.body, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["aurrelle-product-conversion"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializeStickyPurchaseBar = (root = document) => {
      const stickyCard = root.querySelector('[data-aurrelle-sticky-card]')
        || document.querySelector('[data-aurrelle-sticky-card]');
      const mainBuyButton = root.querySelector('[data-lucine-buy-now]')
        || document.querySelector('[data-lucine-buy-now]');

      if (!stickyCard || !mainBuyButton || stickyCard.dataset.aurrelleStickyReady === 'true') return;

      stickyCard.dataset.aurrelleStickyReady = 'true';

      const setMainButtonVisibility = (isVisible) => {
        stickyCard.dataset.mainBuyVisible = isVisible ? 'true' : 'false';
      };

      const mainButtonRect = mainBuyButton.getBoundingClientRect();
      setMainButtonVisibility(mainButtonRect.bottom > 0 && mainButtonRect.top < window.innerHeight);

      const observer = new IntersectionObserver((entries) => {
        setMainButtonVisibility(entries.some((entry) => entry.isIntersecting));
      }, { threshold: 0.01 });

      observer.observe(mainBuyButton);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeStickyPurchaseBar(), { once: true });
    } else {
      initializeStickyPurchaseBar();
    }

    document.addEventListener('shopify:section:load', (event) => initializeStickyPurchaseBar(event.target));
  })();
  } catch(e) { console.error(e); }
})();

})();
